import React, { forwardRef } from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const WhiteButtonWithIcon = forwardRef(({
  icon,
  text,
  onClick,
  disabled = false,
  iconProps = {},
  padding,
  sx = {},
  ...otherProps
}, ref) => {
  const Icon = icon;

  const commonButtonStyles = {
    backgroundColor: 'white',
    color: '#4f4f4f',
    borderRadius: '20px',
    border: '1px solid #e3e3e3',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: '0.7rem',
    fontWeight: '600',
    padding: text ? (padding || '8px 16px') : (padding || '8px'),
    minWidth: text ? 'auto' : '36px',
    width: text ? 'auto' : '36px',
    height: text ? 'auto' : '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: 2,
    },
    '& .MuiButton-startIcon': {
      mr: text ? 1 : 0,
      '& > *:first-of-type': {
        fontSize: iconProps.fontSize || '16px'
      }
    },
    ...sx
  };

  return (
    <Button
      variant="contained"
      sx={commonButtonStyles}
      onClick={onClick}
      disabled={disabled}
      startIcon={<Icon sx={{ color: '#828282', ...iconProps }} />}
      ref={ref}
      {...otherProps}
    >
      {text}
    </Button>
  );
});

WhiteButtonWithIcon.propTypes = {
  icon: PropTypes.elementType.isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  iconProps: PropTypes.object,
  padding: PropTypes.string,
  sx: PropTypes.object
};

WhiteButtonWithIcon.displayName = 'WhiteButtonWithIcon';

export default WhiteButtonWithIcon;